export const ENRICHED_PRODUCTS = [
    {
        isTrackingInventory: false,
        inventory: {
            status: 'in_stock',
            quantity: 0,
            availableForPreOrder: false,
            preOrderInfoView: {
                limit: null,
            },
        },
        name: "I'm a product",
        formattedComparePrice: '',
        sku: '21554345656',
        formattedPrice: '€120.00',
        price: 120,
        digitalProductFileItems: [],
        formattedPricePerUnit: null,
        isInStock: true,
        productType: 'physical',
        options: [
            {
                selections: [
                    {
                        description: 'Small',
                        linkedMediaItems: null,
                        key: 'Small',
                        id: 2,
                        value: 'Small',
                    },
                    {
                        description: 'Large',
                        linkedMediaItems: null,
                        key: 'Large',
                        id: 3,
                        value: 'Large',
                    },
                ],
                optionType: 'DROP_DOWN',
                key: 'Size',
                id: 'opt-20',
                title: 'Size',
            },
        ],
        productItemsPreOrderAvailability: 'no_variants',
        pricePerUnitData: null,
        id: 'demo-product-1',
        itemDiscount: null,
        documentType: 'public/stores/products',
        pricePerUnit: null,
        comparePrice: 0,
        ribbon: '',
        media: [
            {
                mediaType: 'PHOTO',
                url: '22e53e_8adb0d7018b047e0a998acf987fd3fd6~mv2.jpg',
                altText: null,
                height: 3716,
                title: 'Tshirt-Context.jpg',
                width: 3716,
                index: 0,
            },
        ],
        subscriptionPlans: {
            list: [],
        },
        urlPart: 'i-m-a-product-11',
        priceRange: null,
        isManageProductItems: false,
        discount: {
            mode: 'PERCENT',
            value: 0,
        },
        productItems: [],
    },
    {
        isTrackingInventory: false,
        inventory: {
            status: 'in_stock',
            quantity: 0,
            availableForPreOrder: false,
            preOrderInfoView: {
                limit: null,
            },
        },
        name: "I'm a product",
        formattedComparePrice: '',
        formattedPrice: '€7.50',
        price: 7.5,
        digitalProductFileItems: [],
        formattedPricePerUnit: null,
        isInStock: true,
        productType: 'physical',
        options: [
            {
                selections: [
                    {
                        description: 'Small',
                        linkedMediaItems: null,
                        key: 'Small',
                        id: 1,
                        value: 'Small',
                    },
                    {
                        description: 'Large',
                        linkedMediaItems: null,
                        key: 'Large',
                        id: 2,
                        value: 'Large',
                    },
                ],
                optionType: 'DROP_DOWN',
                key: 'Size',
                id: 'opt-20',
                title: 'Size',
            },
        ],
        productItemsPreOrderAvailability: 'no_variants',
        pricePerUnitData: null,
        id: 'demo-product-2',
        itemDiscount: null,
        documentType: 'public/stores/products',
        pricePerUnit: null,
        comparePrice: 0,
        ribbon: 'New',
        media: [
            {
                mediaType: 'PHOTO',
                url: '22e53e_e1b7b337b97b4dd3bb9ed68e2598dc61~mv2.jpg',
                altText: null,
                height: 3709,
                title: 'Glasses-Product.jpg',
                width: 3708,
                index: 0,
            },
        ],
        subscriptionPlans: {
            list: [],
        },
        urlPart: 'i-m-a-product-4',
        priceRange: null,
        isManageProductItems: false,
        discount: {
            mode: 'PERCENT',
            value: 0,
        },
        productItems: [],
    },
    {
        isTrackingInventory: false,
        inventory: {
            status: 'in_stock',
            quantity: 0,
            availableForPreOrder: false,
            preOrderInfoView: {
                limit: null,
            },
        },
        name: "I'm a product",
        formattedComparePrice: '',
        sku: '217537123517253',
        formattedPrice: '€25.00',
        price: 25,
        digitalProductFileItems: [],
        formattedPricePerUnit: null,
        isInStock: true,
        productType: 'physical',
        options: [
            {
                selections: [
                    {
                        description: 'Small',
                        linkedMediaItems: [],
                        key: 'Small',
                        id: 1,
                        value: 'Small',
                    },
                    {
                        description: 'Medium',
                        linkedMediaItems: [],
                        key: 'Medium',
                        id: 2,
                        value: 'Medium',
                    },
                    {
                        description: 'Large',
                        linkedMediaItems: [],
                        key: 'Large',
                        id: 3,
                        value: 'Large',
                    },
                ],
                optionType: 'DROP_DOWN',
                key: 'Size',
                id: 'opt-20',
                title: 'Size',
            },
        ],
        productItemsPreOrderAvailability: 'no_variants',
        pricePerUnitData: null,
        id: '1a2d7e83-4bef-31d5-09e1-3326ee271c09',
        itemDiscount: null,
        documentType: 'public/stores/products',
        pricePerUnit: null,
        comparePrice: 0,
        ribbon: '',
        media: [
            {
                mediaType: 'PHOTO',
                url: '22e53e_01575d792adb43a6a16595bd74a1cc8d~mv2.jpg',
                altText: null,
                height: 2662,
                title: 'Sweater-Product.jpg',
                width: 2662,
                index: 0,
            },
        ],
        subscriptionPlans: {
            list: [],
        },
        urlPart: 'i-m-a-product-3',
        priceRange: null,
        isManageProductItems: false,
        discount: {
            mode: 'PERCENT',
            value: 0,
        },
        productItems: [],
    },
    {
        isTrackingInventory: false,
        inventory: {
            status: 'in_stock',
            quantity: 0,
            availableForPreOrder: false,
            preOrderInfoView: {
                limit: null,
            },
        },
        name: "I'm a product",
        formattedComparePrice: '',
        sku: '364215376135199',
        formattedPrice: '€85.00',
        price: 85,
        digitalProductFileItems: [],
        formattedPricePerUnit: null,
        isInStock: true,
        productType: 'physical',
        options: [
            {
                selections: [
                    {
                        description: '80 ml',
                        linkedMediaItems: null,
                        key: '80 ml',
                        id: 1,
                        value: '80 ml',
                    },
                    {
                        description: '250 ml',
                        linkedMediaItems: null,
                        key: '250 ml',
                        id: 2,
                        value: '250 ml',
                    },
                    {
                        description: '500 ml',
                        linkedMediaItems: null,
                        key: '500 ml',
                        id: 3,
                        value: '500 ml',
                    },
                ],
                optionType: 'DROP_DOWN',
                key: 'Size',
                id: 'opt-20',
                title: 'Size',
            },
        ],
        productItemsPreOrderAvailability: 'no_variants',
        pricePerUnitData: null,
        id: 'ea77f230-558f-57b6-cdd1-0ba565e8f827',
        itemDiscount: null,
        documentType: 'public/stores/products',
        pricePerUnit: null,
        comparePrice: 0,
        ribbon: '',
        media: [
            {
                mediaType: 'PHOTO',
                url: '22e53e_4f99aa57e6a04e6dbcdbfe474fc1654f~mv2.jpg',
                altText: null,
                height: 4000,
                title: 'Cream-Context.jpg',
                width: 4000,
                index: 0,
            },
        ],
        subscriptionPlans: {
            list: [],
        },
        urlPart: 'i-m-a-product-6',
        priceRange: null,
        isManageProductItems: false,
        discount: {
            mode: 'PERCENT',
            value: 0,
        },
        productItems: [],
    },
];
//# sourceMappingURL=enrichedProductsData.js.map